module.exports = __webpack_public_path__ + "logos/logo-bitbucket-server.427a04.svg";